import { __extends } from "tslib";
import Manager from '../Abstracts/Manager';
var TranslationManager = /** @class */ (function (_super) {
    __extends(TranslationManager, _super);
    /* CONSTRUCTOR */
    function TranslationManager(translations) {
        var _this = _super.call(this) || this;
        _this._translations = translations;
        return _this;
    }
    /* METHODS */
    TranslationManager.prototype.translate = function (key, language) {
        try {
            var word = "";
            word = this._translations[key][language];
            if (word == "") {
                return "[" + key + "]";
            }
            return word;
        }
        catch (_a) {
            return "[" + key + "]";
        }
    };
    TranslationManager.prototype.translateUpperCase = function (key, language) {
        return this.translate(key, language).toUpperCase();
    };
    return TranslationManager;
}(Manager));
export default TranslationManager;
